export default __webpack_public_path__ + "static/media/EmptyOrder.a0c49ae4.png";